import { useEffect } from "react";
import Lenis from "lenis";
import Seo from "@/components/Seo";
import NavigationHeader from "@/components/NavigationHeader";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import McaExplainerGrid from "@/components/McaExplainerGrid";
import BrokerAdvantageSection from "@/components/BrokerAdvantageSection";
import NumberedManifesto from "@/components/NumberedManifesto";
import QualificationFunnel from "@/components/QualificationFunnel";
import Footer from "@/components/Footer";

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#07090D] text-zinc-100" data-testid="landing-page">
      <Seo
        title="Forward Exspansion — Commercial Capital in Hours, Not Weeks"
        siteName="Forward Exspansion"
        description="Forward Exspansion syndicates your revenue across 30+ institutional lenders, forcing a bidding war that funds your business in 4 to 24 hours. No collateral. No liens. Check pre-approval status now."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FinancialService",
          name: "Forward Exspansion",
          description:
            "Independent commercial finance brokerage specializing in merchant cash advance syndication across 30+ institutional lenders.",
        }}
      />
      <NavigationHeader />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <McaExplainerGrid />
        <BrokerAdvantageSection />
        <NumberedManifesto />
        <QualificationFunnel />
      </main>
      <Footer />
    </div>
  );
}
